<template>
  <div id="SectionReducedEnergyCosts">
    <UIContainer class="SectionReducedEnergyCosts__container">
      <template #left>
        <img
          class="SectionReducedEnergyCosts__image"
          src="../assets/reducedEnergyCosts/bg.avif"
          alt="Governance & Controls (Factors, Scope 2, Evidence Vault)"
          loading="lazy"
        />
      </template>

      <template #right>
        <div class="SectionReducedEnergyCosts__content">
          <ReviewCard
            :rating="5"
            name="— Plant Manager"
            jobTitle="Automotive Supplier"
          >
            <template #text>
              <h1>“Reduced energy costs by 23% while cutting emissions 40%”</h1>
            </template>
          </ReviewCard>
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import ReviewCard from '@/views/components/cards/ReviewCard.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
</script>

<style lang="scss" scoped>
#SectionReducedEnergyCosts {
  position: relative;
  padding: 4rem 0;

  .SectionReducedEnergyCosts__container {
    background-color: $color-ui-gray-cool-50;
    padding-top: 0;
    padding-bottom: 0;

    @include md {
      :deep(.UIContainer__grid) {
        display: flex;
        .UIContainer__left {
          width: 40%;
          padding: 2rem 1rem;
        }
        .UIContainer__right {
          width: 60%;
        }
      }
    }
  }

  .SectionReducedEnergyCosts__image {
    display: none;
    width: 100%;
    max-height: 32rem;
    border-radius: 1.5rem;

    @include md {
      display: block;
      right: 0;
    }
  }

  .SectionReducedEnergyCosts__content {
    @include md {
      margin-left: 2rem;
    }
    .ReviewCard {
      max-width: 100%;
    }

    h1 {
      font-size: 2.25rem;
      line-height: 2.75rem;
      font-weight: 500;
      margin-bottom: 2rem;
    }
  }

  .SectionReducedEnergyCosts__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionReducedEnergyCosts__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionReducedEnergyCosts__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionReducedEnergyCosts__feature-icon {
    --size: 1.75rem;
  }

  .SectionReducedEnergyCosts__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
